import { getInverseRgba } from '~app/helpers/luminance';

// This func will help determine if we need to change the text color of either the header/body text, depending on what color the background is.
// A color is considered visible if it is not the same as the background color (ex: rgba(0,0,0,1)== rgba(0,0,0,1) --> not visible)
export function evaluateTextColorVisibility(color1, color2, backgroundColor) {
  const color1IsNotVisible = color1 === backgroundColor;
  const color2IsNotVisible = color2 === backgroundColor;
  const inverseRgba = color1IsNotVisible && color2IsNotVisible ? getInverseRgba(color1) : '';

  if (color1IsNotVisible) {
    if (color2IsNotVisible) {
      return inverseRgba; // If the header and body are both not visible, then use the inverse of color1
    }
    return color2; // If the color1 is not visible, but color2 is, then use color2
  }
  return color1; // If color1 is visible, then use it
}

export function getThemeColors(theme) {
  // We need to check two locations for the colors because the location changes between v2 and v3 themes
  return {
    headerTextColor: theme?.titleColor || theme?.pageTitle?.color,
    bodyTextColor: theme?.questionColor || theme?.questionTitle?.color,
    backgroundColor: theme?.primaryBackgroundColor ? theme?.primaryBackgroundColor : 'rgba(255,255,255,1)', // backgroundColor (if survey uses v2 themes, background will default to white)
  };
}
